import $ from 'jquery';
import 'jquery.cookie';

import { exportGetScript, banners, getScript } from '../../../src/js/common/utils/fn';
import '../consent/msnt-consent';

window.$ = $;
window.jQuery = $;

window.fn = window.fn ?? {};
window.getScript = exportGetScript;

Object.assign(window.fn, {
  getScript,
});

window.googletag = window.googletag || {};
window.googletag.cmd = window.googletag.cmd || [];

banners();

// msntConsent.initShareBlock($('.postBody'));
